import { EXPRESS_API } from 'configs/api/expressApi';
import axios from 'axios';

export const useUploadFile = () => {
  const uploadFile = async (
    file: File,
    onProgress?: (progress: number) => void
  ) => {
    onProgress?.(0);
    const data = {
      filename: file.name,
      filetype: file.type,
    };
    const response = await EXPRESS_API.post(
      `/aws/signedurl/user-uploaded-public-files`,
      data
    );

    const url = response.data.uploadUrl;

    await axios.put(url, file, {
      headers: { 'content-type': file.type },
      onUploadProgress: progressEvent => {
        if (progressEvent.total) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress?.(percentCompleted);
        }
      },
    });

    let downloadUrl = response.data.downloadUrl;
    onProgress?.(100);
    return downloadUrl;
  };

  return { uploadFile };
};
